export default function PrintablePatient({ patient, selectedKeys }) {
  const clinicalKeys = [
    "presentcomplaint", "pasthistory", "head", "eyes", "ears", "mouth",
    "nose", "throat", "chest", "abdomen", "appetite", "thrist", "urine",
    "stool", "sleep", "mind", "ext", "skin", "sweat", "female", "thermal",
    "investigation", "face", "physiology", "familyhistory", "male", "treatment"
  ];

  const clinical = clinicalKeys
    .filter((k) => selectedKeys.has(k) && patient[k]?.trim?.())
    .map((k) => ({
      label: k
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, str => str.toUpperCase())
        .replace(/\b\w/g, l => l.toUpperCase()),
      value: patient[k],
    }));

  return (
    <div
      className="bg-white print:bg-white print:shadow-none print:rounded-none"
      style={{
        padding: "2rem",
        width: "210mm",
        minHeight: "297mm",
        margin: "0 auto",
        boxSizing: "border-box"
      }}
    >
      {/* Header */}
      <div className="text-center border-b pb-4 mb-6">
        <h1 className="text-4xl font-extrabold text-green-800 uppercase">
          Aarogyam Homoeopathic Clinic
        </h1>
      </div>

      {/* Patient Info */}
      <div className="space-y-2 text-base sm:text-lg leading-relaxed mb-6">
        <div className="text-2xl font-bold text-green-800">
          {patient.firstname} {patient.lastname}
        </div>
        <div><strong>Reg. No:</strong> {patient.registration_number}</div>
        <div><strong>Age / Gender:</strong> {patient.age} / {patient.gender}</div>
        <div><strong>Weight (kg):</strong> {patient.wt || "—"}</div>
        <div><strong>Blood Pressure:</strong> {patient.bp || "—"}</div>
      </div>

      {/* Clinical Data */}
      {clinical.length > 0 && (
        <div className="mt-6 space-y-4">
          <h2 className="text-xl font-bold text-green-700 border-b pb-1">Clinical Case Details</h2>
          {clinical.map(({ label, value }) => (
            <div key={label}>
              <h3 className="font-semibold text-green-700">{label}</h3>
              <p className="ml-2">{value}</p>
            </div>
          ))}
        </div>
      )}

      {/* Notes */}
      <div className="mt-6 border-t pt-4">
        <p className="text-lg"><strong>Extra Notes:</strong> _________________________________</p>
        <p className="text-lg mt-2"><strong>Follow-up:</strong> _________________________________</p>
      </div>

      {/* Footer with Signature */}
      <div
        className="flex justify-between items-end mt-10 text-sm text-gray-600"
        style={{ pageBreakInside: "avoid" }}
      >
        <div className="italic">Powered by Aarogyam Clinic Records</div>
        <div className="text-right" style={{ maxWidth: "40%", wordBreak: "break-word" }}>
          <p className="font-semibold">Dr. Nidhi Malviya</p>
          <p className="italic">Signature & Seal</p>
          <div
            className="mt-1 w-28 h-16 border border-gray-400 rounded bg-gray-100 print:border-black print:bg-white"
            style={{ maxWidth: "100%" }}
          ></div>
        </div>
      </div>
    </div>
  );
}
